import React, { useEffect, useState } from 'react'
import TicketForm, {
  TicketInputDataType,
  TicketOutputDataType,
} from '../components/forms/TicketForm'
import { useClaimant } from '../context/col'
import useAsync from '../hooks/useAsync'
import useGetData from '../hooks/useGetData'
import {
  CaseReportParamsType,
  CaseReportRespType,
  transformCaseReportRespToCaseReportParams,
} from '../models'
import { putCaseReport } from '../services/case-report/put'

export type TicketPageProps = {
  transitions: TicketPageTransitions
}

export type TicketPageTransitions = {
  goBack: () => void
  goToNextPage: () => void
}

const Ticket = (props: TicketPageProps) => {
  const { state, dispatch } = useClaimant()
  const [ifEqual, setIfEqual] = useState<boolean>(true)

  useEffect(() => {
    dispatch({ type: 'control_change', payload: { controlChange: ifEqual } })
  }, [ifEqual])

  const { fetch: fetchData } = useGetData({})

  useEffect(() => {
    fetchData()
  }, [])

  const handleTicketPageBack = () => {
    // history.push(pathToClaimant)
    props.transitions.goBack()
  }

  const handleTicketPageSubmitted = (value: TicketOutputDataType) => {
    if (state.loadedCaseReportResp == null) {
      throw new Error('Illegal state -- no loadedCaseReportResp')
    }
    const origCaseReportResp: CaseReportRespType = state.loadedCaseReportResp
    const newCaseReportDataResp: CaseReportRespType = {
      ...origCaseReportResp,
      caseTI: value.caseTI,
      caseCommon: value.caseCommon,
    }

    const caseReportParamsForUpdate: CaseReportParamsType =
      transformCaseReportRespToCaseReportParams(newCaseReportDataResp)

    dispatch({
      type: 'update_caseReportParams',
      payload: { data: newCaseReportDataResp, page: 4 },
    })

    doPutCaseReport({
      caseReportId: state.caseReportId,
      caseReportParams: caseReportParamsForUpdate,
    })
  }

  function handleTicketDataChanged(isChanged: boolean): void {
    setIfEqual(isChanged)
  }

  const { fetch: doPutCaseReport, pending } = useAsync({
    promiseFn: (params: any) => putCaseReport(params),
    onData: () => {
      dispatch({ type: 'control_change', payload: { controlChange: true } })
      //history.push(pathToBankAccount)
      props.transitions.goToNextPage()
    },
    onError: (error) => {
      dispatch({ type: 'error', payload: { error: error.message } })
    },
  })

  const ticketFormData: TicketInputDataType = {
    caseTI: state.loadedCaseReportResp?.caseTI ?? null,
    caseCommon: state.loadedCaseReportResp?.caseCommon ?? null,
  }

  return (
    <TicketForm
      caseReportId={state.caseReportId!}
      data={ticketFormData}
      isPageConfirmInProgress={pending}
      errorMessage={state.error}
      onPageContinue={handleTicketPageSubmitted}
      onPageBack={handleTicketPageBack}
      notifyDataChanged={handleTicketDataChanged}
    />
  )
}

export default Ticket
